import React, { useRef, useState } from 'react';
import './dice.css';

const DICE_SOUND = '/assets/whoispaying/Cube_Rumble.mp3';

// Map dice value to cube rotation (degrees)
const faceRotation = {
  1: { x: 0, y: 0 },      // front
  2: { x: 0, y: -90 },   // right
  3: { x: 0, y: 180 },   // back
  4: { x: 0, y: 90 },    // left
  5: { x: -90, y: 0 },   // top
  6: { x: 90, y: 0 },    // bottom
};

export default function Dice({ currentFace = 1, nextFace = 1, onReveal, disabled }) {
  const audioRef = useRef(null);
  // Track the total accumulated rotation
  const [rotation, setRotation] = useState(faceRotation[currentFace]);
  const [rolling, setRolling] = useState(false);
  const [pendingFace, setPendingFace] = useState(currentFace);

  // Pip positions for each face
  const pips = {
    1: ['c'],
    2: ['tl', 'br'],
    3: ['tl', 'c', 'br'],
    4: ['tl', 'tr', 'bl', 'br'],
    5: ['tl', 'tr', 'c', 'bl', 'br'],
    6: ['tl', 'ml', 'bl', 'tr', 'mr', 'br'],
  };

  const handleRoll = () => {
    if (disabled || rolling) return;
    setRolling(true);
    setPendingFace(nextFace);
    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play();
    }
    // Add random full spins to both axes for realism
    const randX = 360 * (2 + Math.floor(Math.random() * 2));
    const randY = 360 * (2 + Math.floor(Math.random() * 2));
    // New rotation is current + random spins + final face
    setRotation(prev => ({
      x: prev.x + randX + (faceRotation[nextFace].x - faceRotation[currentFace].x),
      y: prev.y + randY + (faceRotation[nextFace].y - faceRotation[currentFace].y),
    }));
    setTimeout(() => {
      setRolling(false);
      setPendingFace(nextFace);
      if (onReveal) onReveal();
    }, 900);
  };

  // Find which face to show pips for (after roll, show nextFace; during, show pendingFace)
  const faceToShow = rolling ? pendingFace : nextFace;

  return (
    <button
      className={`dice-cube-btn${rolling ? ' rolling' : ''}`}
      type="button"
      onClick={handleRoll}
      disabled={disabled || rolling}
      aria-label="Roll dice"
      style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
    >
      <div className="dice-cube-3d-scene">
        <div
          className="dice-cube-3d"
          style={{
            transform: `rotateX(${rotation.x}deg) rotateY(${rotation.y}deg)`,
            transition: rolling ? 'transform 0.9s cubic-bezier(.36,.07,.19,.97)' : 'transform 0.3s',
          }}
        >
          <div className="dice-cube-face dice-cube-1">{pips[1].map((pos, i) => <span key={i} className={`pip-basic ${pos}`} />)}</div>
          <div className="dice-cube-face dice-cube-2">{pips[2].map((pos, i) => <span key={i} className={`pip-basic ${pos}`} />)}</div>
          <div className="dice-cube-face dice-cube-3">{pips[3].map((pos, i) => <span key={i} className={`pip-basic ${pos}`} />)}</div>
          <div className="dice-cube-face dice-cube-4">{pips[4].map((pos, i) => <span key={i} className={`pip-basic ${pos}`} />)}</div>
          <div className="dice-cube-face dice-cube-5">{pips[5].map((pos, i) => <span key={i} className={`pip-basic ${pos}`} />)}</div>
          <div className="dice-cube-face dice-cube-6">{pips[6].map((pos, i) => <span key={i} className={`pip-basic ${pos}`} />)}</div>
        </div>
      </div>
      <audio ref={audioRef} src={DICE_SOUND} preload="auto" />
    </button>
  );
}
